import { useEffect, useState } from 'react';

export type ConsentValue = 'accepted' | 'essential' | null;

const STORAGE_KEY = 'cookie-consent';
const EVENT_NAME = 'cookie-consent-change';

export function getConsent(): ConsentValue {
  if (typeof window === 'undefined') return null;
  const v = localStorage.getItem(STORAGE_KEY);
  return v === 'accepted' || v === 'essential' ? v : null;
}

export function setConsent(value: 'accepted' | 'essential') {
  localStorage.setItem(STORAGE_KEY, value);
  window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: value }));
}

export function useCookieConsent() {
  const [consent, setState] = useState<ConsentValue>(() => getConsent());

  useEffect(() => {
    const handler = () => setState(getConsent());
    window.addEventListener(EVENT_NAME, handler);
    window.addEventListener('storage', handler);
    return () => {
      window.removeEventListener(EVENT_NAME, handler);
      window.removeEventListener('storage', handler);
    };
  }, []);

  return {
    consent,
    hasMadeChoice: consent !== null,
    marketingAllowed: consent === 'accepted',
  };
}
